import { render, staticRenderFns } from "./CromoFooter.vue?vue&type=template&id=7f17bd84"
import script from "./CromoFooter.vue?vue&type=script&lang=ts"
export * from "./CromoFooter.vue?vue&type=script&lang=ts"
import style0 from "./CromoFooter.vue?vue&type=style&index=0&id=7f17bd84&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports